module.exports = __webpack_public_path__ + "static/media/frog(12).f7f22ec3.PNG";